var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoy4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1300,
    height: 1300,
    viewBox: "0 0 1300 1300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M650 1300C290.71 1300 0 1008.86 0 650C0 290.71 291.141 0 650 0C1009.29 0 1300 291.141 1300 650C1300.43 1009.29 1009.29 1300 650 1300Z",
    fill: "#A193EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_32_1452",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1301,
    height: 1300
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M650 1300C290.71 1300 0 1008.86 0 650C0 290.71 291.141 0 650 0C1009.29 0 1300 291.141 1300 650C1300.43 1009.29 1009.29 1300 650 1300Z",
    fill: "#F7C0B5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_32_1452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1014.87 1197.33C1011.83 1199.5 1008.37 1201.66 1005.33 1203.83C1001.87 1206 998.833 1208.16 995.366 1209.9C992.333 1211.63 989.733 1213.36 986.699 1215.1C986.266 1215.53 985.833 1215.53 985.399 1215.96C975.433 1222.03 965.033 1227.66 954.633 1232.86C951.599 1234.6 948.133 1236.33 945.099 1237.63C945.099 1237.63 944.666 1238.06 944.233 1238.06C940.766 1239.8 937.299 1241.53 933.833 1243.26C926.899 1246.73 919.533 1249.76 912.599 1252.8C909.133 1254.53 905.233 1255.83 901.766 1257.13C898.299 1258.43 894.399 1260.16 890.933 1261.46C887.466 1262.76 883.566 1264.5 880.099 1265.8C880.099 1265.8 880.099 1265.8 879.666 1265.8C876.199 1267.1 872.299 1268.4 868.833 1269.7C861.033 1272.3 852.799 1274.9 844.999 1277.5C842.399 1278.36 839.366 1279.23 836.766 1280.1C828.533 1282.7 820.299 1284.86 812.066 1286.6C809.033 1287.46 805.999 1287.9 802.533 1288.76C794.733 1290.5 786.499 1292.23 778.699 1293.96C776.966 1294.4 775.666 1294.4 773.933 1294.83C771.333 1295.26 768.299 1295.7 765.699 1296.13C761.799 1296.56 758.333 1297.43 754.433 1297.86C752.699 1298.3 750.966 1298.3 749.233 1298.73C747.066 1299.16 744.466 1299.6 741.866 1299.6C734.933 1300.46 727.566 1301.33 720.633 1302.2C718.466 1302.63 715.866 1302.63 713.699 1303.06H713.266C710.233 1303.5 707.199 1303.5 704.166 1303.93C701.133 1304.36 698.099 1304.36 695.066 1304.36C693.333 1304.36 691.166 1304.8 689.433 1304.8C685.966 1304.8 682.933 1305.23 679.899 1305.23C675.566 1305.23 671.666 1305.66 667.333 1305.66C662.999 1305.66 659.099 1305.66 654.766 1305.66C651.733 1305.66 648.699 1305.66 645.666 1305.66C463.233 1303.06 298.566 1225.5 181.566 1102.43C181.566 1102.43 181.566 1102 181.133 1102C194.566 1075.56 244.399 1027.9 296.399 988.464C362.266 938.631 455.433 907.865 455.433 907.865C455.433 907.865 516.533 897.898 743.166 945.131C916.066 981.531 989.733 1129.3 1014.87 1197.33Z",
    fill: "#AD827B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.266 1065.16C782.166 1109.8 723.232 1136.23 623.999 1096.36C502.233 1046.96 455.433 907.865 455.433 907.865C448.933 808.198 433.766 722.831 433.766 722.831C574.599 710.698 740.999 875.365 740.999 875.365L760.066 956.831C761.799 963.764 765.266 969.831 770.466 974.165C779.566 989.764 797.332 1036.56 791.266 1065.16Z",
    fill: "#AD827B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.466 974.598C687.699 970.265 626.599 958.131 561.166 840.698C616.633 889.665 682.066 908.298 750.966 916.965L760.066 956.831C761.799 964.198 765.266 970.265 770.466 974.598Z",
    fill: "#8E5650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.632 452.431C949.432 488.831 953.332 518.298 932.099 615.365C910.866 712.431 951.599 809.498 849.332 898.331C780.432 958.131 659.966 969.398 563.766 903.965C531.266 881.865 501.366 851.098 477.099 810.798C458.032 779.165 435.932 749.265 411.232 721.965C376.999 684.698 335.832 609.731 356.199 477.131C389.132 261.331 602.766 236.631 728.866 260.465C854.966 284.298 920.399 356.231 941.632 452.431Z",
    fill: "#AD827B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.933 621.865C526.933 621.865 513.5 556.865 450.233 564.665C395.633 571.598 376.566 702.465 500.5 738.865",
    fill: "#AD827B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.6 679.498C496.6 679.498 481 669.531 482.733 652.198C485.333 631.831 482.733 619.265 473.2 615.365C449.366 605.398 444.6 633.131 445.466 636.598",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.233 721.531C827.233 721.531 843.7 722.398 859.3 703.765C867.966 693.365 875.333 680.365 870.566 676.465C865.8 672.131 787.366 684.265 782.166 694.665C776.966 705.065 807.3 721.531 827.233 721.531Z",
    fill: "#8E605C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.233 575.931C840.233 575.931 841.099 617.098 867.533 663.031C879.233 683.398 861.466 716.765 822.899 722.398",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.385 947.754C496.385 947.754 487.718 894.021 472.985 897.054C404.518 912.654 204.752 970.721 134.985 1121.52C69.1184 1264.95 63.0518 1466.02 63.0518 1466.02H1158.95C1158.95 1466.02 1139.02 1160.52 1027.22 1066.92C960.918 1011.02 901.118 976.788 852.152 955.988C787.152 928.254 721.718 986.321 703.085 985.021C669.718 983.288 496.385 947.754 496.385 947.754Z",
    fill: "#544D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.552 1466.02L258.052 1305.25",
    stroke: "white",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.15 1250.65C1034.15 1250.65 1021.15 1282.29 1025.05 1313.92C1028.95 1345.55 1040.22 1391.92 1024.19 1466.02",
    stroke: "white",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.552 853.287C446.552 853.287 415.352 864.554 409.719 870.621C404.085 876.687 401.485 880.587 401.485 880.587C401.485 880.587 385.885 897.921 377.219 939.954C373.319 957.721 382.419 986.754 375.485 1009.72C355.552 1073.42 450.019 1171.35 606.019 1228.99C724.319 1272.75 854.752 1232.89 872.952 1150.55C890.285 1071.25 879.885 1035.29 871.652 1009.72C855.185 960.321 849.985 946.454 827.885 927.387C814.019 915.254 804.485 940.387 752.485 954.687C736.452 959.021 716.952 962.487 691.819 963.354C542.319 968.987 479.052 884.054 456.519 859.787C450.885 855.021 448.285 852.421 446.552 853.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.185 954.254C735.152 958.587 715.652 962.054 690.518 962.921C541.018 968.554 477.752 883.621 455.218 859.354",
    stroke: "#CCCCCC",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.485 911.788C869.919 944.721 938.385 1030.95 921.919 1223.79C913.685 1319.12 960.052 1358.55 949.652 1373.72C947.919 1376.32 945.752 1377.62 944.019 1378.05C936.652 1379.79 929.719 1383.25 926.252 1390.19C924.952 1393.22 922.785 1395.39 919.752 1397.12C917.152 1398.85 914.119 1398.85 911.519 1398.42C902.419 1396.25 892.452 1401.45 886.819 1409.25C884.652 1412.29 882.052 1414.45 878.152 1415.32C875.552 1416.19 872.952 1415.75 871.219 1415.32C863.852 1413.15 855.619 1415.32 849.119 1420.52C847.385 1421.82 845.652 1422.69 843.485 1422.69C839.585 1422.69 836.552 1420.95 833.952 1418.35C827.885 1412.72 819.219 1410.55 810.552 1413.59C809.685 1414.02 809.252 1414.02 808.385 1414.02C802.319 1414.89 797.552 1410.12 794.085 1401.89C790.619 1394.09 782.385 1390.62 773.719 1391.49C771.985 1391.49 770.252 1391.49 768.085 1391.05C751.185 1387.15 729.519 1363.75 729.085 1335.15C728.652 1306.99 735.152 1258.02 745.985 1235.05C779.352 1164.42 791.485 1113.72 793.219 1075.59C796.685 1005.82 752.485 943.421 756.819 942.121C801.019 933.021 830.485 911.788 830.485 911.788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.552 1235.05C778.918 1164.42 791.052 1113.72 792.785 1075.59C795.385 1021.85 769.385 972.021 759.852 951.654",
    stroke: "#CCCCCC",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.652 1335.15C728.218 1306.99 734.718 1258.02 745.552 1235.05C778.918 1164.42 791.052 1113.72 792.785 1075.59",
    stroke: "#CCCCCC",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.219 1183.92C767.219 1183.92 635.486 1196.92 548.819 1131.49",
    stroke: "#CCCCCC",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.753 955.554C814.886 973.321 828.753 999.321 832.22 1031.39",
    stroke: "#CCCCCC",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.786 1415.32C857.786 1415.32 835.686 1368.52 857.786 1266.69C881.186 1158.35 870.353 1105.05 870.353 1105.05",
    stroke: "#CCCCCC",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.352 961.621C376.352 961.621 405.385 1021.42 440.485 1049.15",
    stroke: "#CCCCCC",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.32 1105.05C789.32 1105.05 706.986 1110.69 648.919 1088.15",
    stroke: "#CCCCCC",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.043 526.549C752.576 527.849 759.943 517.882 756.476 508.349C754.743 503.149 751.709 498.382 746.943 495.349C732.209 486.249 677.176 485.382 648.143 506.182C622.576 525.249 699.709 520.482 743.043 526.549Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.074 531.315C855.274 531.315 850.508 521.349 854.408 513.115C856.574 508.782 859.608 504.882 863.941 502.715C877.374 496.215 913.341 500.115 929.374 522.215C943.674 541.715 899.041 530.882 863.074 531.315Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.876 581.148C694.076 595.449 656.376 577.682 656.376 577.682",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.042 589.816C899.042 589.816 875.642 604.116 846.175 587.216",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.158 772.845C804.607 780.033 799.215 792.613 789.331 801.599C738.562 770.598 715.648 786.773 715.648 786.773C697.677 759.366 701.72 722.075 745.301 750.38C775.852 769.7 794.273 772.845 804.158 772.845Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.331 801.599C778.549 811.034 762.374 816.875 740.359 807.889C730.026 803.846 721.938 795.758 715.648 786.773C715.648 786.773 738.562 770.598 789.331 801.599Z",
    fill: "#FE9DAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.695 771.048C812.695 771.048 793.825 781.381 745.302 750.381C687.344 713.09 699.025 791.266 739.91 807.889C782.592 825.411 804.608 787.222 804.158 772.845",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.648 786.773C715.648 786.773 738.562 770.598 789.331 801.599",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.83 400.553C1025.83 345.953 989 300.453 939.167 286.153C941.767 275.32 942.2 264.053 939.6 252.353C930.934 214.653 897.134 188.22 858.567 190.82C843.4 191.686 829.1 197.32 817.4 205.986C799.2 163.953 757.167 134.486 708.634 134.486C657.067 134.486 613.3 167.42 596.834 213.353C578.634 191.686 551.334 177.82 521 177.82C468.134 177.82 424.8 219.42 422.2 271.853C413.967 269.253 404.867 267.953 395.767 268.386C360.667 270.553 332.067 299.153 329.467 334.253C328.6 345.953 330.767 357.22 335.1 367.62C285.7 372.82 247.134 414.853 247.134 465.553C247.134 503.686 268.8 537.053 300.867 553.52C287.867 566.52 279.634 584.286 279.634 603.786C279.634 640.186 307.367 670.52 342.9 674.42C340.734 681.353 339.867 689.586 342.467 697.82C346.367 712.12 358.067 723.386 372.367 726.42C381.034 728.153 389.267 727.286 396.634 724.253C400.534 729.886 404.434 734.653 407.9 738.986C412.234 744.186 415.7 748.953 419.167 753.72C439.1 782.32 484.6 769.753 486.334 735.086C486.334 734.653 486.334 734.653 486.334 734.22C378 692.62 397.5 571.72 450.367 564.786C505.834 557.853 523.167 607.253 526.2 619.386C585.567 581.253 501.067 443.886 588.167 403.153C665.734 367.186 747.2 421.786 846.867 435.22C883.7 440.42 918.367 404.02 933.967 424.386C937 433.486 939.6 442.586 941.767 452.12C948.7 482.886 952.167 508.886 940.467 574.753C969.067 559.153 982.934 535.753 985.534 512.786C986.4 504.986 986.4 496.753 985.967 488.953C1010.23 467.72 1025.83 436.086 1025.83 400.553Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.158 636.126C477.158 636.126 442.492 630.926 445.092 679.459C446.392 704.159 446.392 717.593 445.958 724.526C445.525 729.293 448.558 733.626 452.892 735.359C458.092 737.526 463.725 735.359 466.325 730.159C470.225 723.226 474.558 713.693 474.558 705.893C474.558 692.893 488.425 681.193 488.425 681.193C488.425 681.193 475.858 670.359 477.158 636.126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.025 1471.59C578.559 1467.69 442.492 1234.99 462.859 1147.46C476.725 1087.23 458.525 1017.89 442.492 956.793C435.992 931.659 429.925 908.259 426.459 887.459C420.392 851.493 424.725 817.259 439.459 785.626C455.492 750.093 452.892 719.326 452.892 718.893L461.559 718.026C461.559 719.326 464.159 751.826 447.259 789.093C433.392 818.993 429.492 851.926 435.125 886.159C438.592 906.526 444.659 929.926 451.159 955.059C467.625 1017.03 485.825 1087.66 471.525 1150.06C452.459 1233.26 588.092 1465.96 588.959 1466.83L582.025 1471.59Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.392 704.592C446.826 714.126 446.392 720.626 446.392 724.526C445.959 729.292 448.992 733.626 453.326 735.359C458.526 737.526 464.159 735.359 466.759 730.159C470.659 723.226 474.992 713.692 474.992 705.892C474.992 705.459 474.992 704.592 474.992 704.159C465.892 707.626 455.492 710.226 446.392 704.592Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.159 992.759C851.125 1012.69 850.692 1044.33 849.825 1081.16C848.525 1152.23 806.492 1429.13 786.125 1472.89L778.325 1469.43C797.825 1426.96 839.859 1151.36 841.159 1081.16C842.025 1044.33 842.459 1012.26 845.492 991.459C851.992 947.692 847.225 914.759 844.625 900.892C845.925 899.592 847.225 898.726 848.525 897.426C849.825 896.559 850.692 895.259 851.992 894.392C854.592 905.659 861.959 941.626 854.159 992.759Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoy4);
export default __webpack_public_path__ + "static/media/Boy_4.aa17d6b1f63200bbd2bfada365a7be9f.svg";
export { ForwardRef as ReactComponent };